import React, {FC} from "react"

import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"

import {resizeCloudinaryImage} from "@irati/utils/images"
import {StyledImage, StyledImageTile, StyledContentWrapper} from "./styled"
import Message from "./Message"

interface Props {
  companyNewsTile: CompanyNewsTile
}

const ImageTile: FC<Props> = ({companyNewsTile}) => {
  const {imageUrl, message, type} = companyNewsTile.config
  if (type !== CompanyNewsTileType.Image) {
    return null
  }

  const tileImage = resizeCloudinaryImage(imageUrl, 600, 338)

  return (
    <StyledImageTile>
      <StyledContentWrapper>
        <StyledImage imageUrl={tileImage} />
      </StyledContentWrapper>
      <Message message={message} />
    </StyledImageTile>
  )
}

export default ImageTile
